<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary" @click="backParent">Workshop</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Workshop</a>
              </li>
              <li class="breadcrumb-item active">
                <span v-if="workshop.id === null">New</span>
                <span v-else>{{ workshop.workshop }}</span>
              </li>
            </ol>
            <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="actionSales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
            <div class="dropdown-menu" aria-labelledby="actionSales">
              <a class="dropdown-item" href="javascript:void(0)" @click="print('invoice')">Print</a>
            </div>
            <button type="button" @click="createWorkshop" class="btn btn-sm btn-soft-primary pull-left" v-if="workshop.id === null">Save</button>
            <button type="button" @click="updateWorkshop" class="btn btn-sm btn-soft-primary pull-left" v-else>Update</button>
            <button type="button" @click="nextProcess" class="btn btn-sm btn-hard-primary pull-left" v-if="workshop.id !== null">Next</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-list">
          <div class="card-header">
            <h5 v-if="workshop.workshop_no === null">New</h5>
              <h5 v-else>
                {{ workshop.workshop_no }}
                <span class="badge badge-primary">{{ workshop.status }}</span>
              </h5>
          </div>
          <div class="card-body">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
              <ul v-for="(a, index) in alert" :key="index">
                <li v-html="a"></li>
              </ul>
            </div>
            <div class="row">
              <div class="col-md-12">
                <dl class="row dl-custom font-12">
                  <dt class="col-md-2"><h5 class="text-ref-sales"><b>Service Type</b></h5></dt>
                  <dd class="col-md-10">
                    <div class="form-check form-check-inline" v-for="g in workshopTypeList" :key="g.id">
                      <input class="form-check-input" type="radio" :id="g.id" :value="g.id" v-model="workshop.type_id" :disabled="workshop.lock">
                      <label class="form-check-label" :for="g.id">{{ g.name }}</label>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-md-4">
                <h5 class="text-ref-sales"><b>Customer</b></h5>
                <dl class="row dl-custom font-12">
                  <dt class="col-md-4">Customer No</dt>
                  <dd class="col-md-8">{{ workshop.customer_no }}</dd>
                  <dt class="col-md-4">Name</dt>
                  <dd class="col-md-8">{{ workshop.customer.name }}</dd>
                  <dt class="col-md-4">Phone</dt>
                  <dd class="col-md-8">{{ workshop.customer.phone }}</dd>
                  <dt class="col-md-4">Address</dt>
                  <dd class="col-md-8">{{ workshop.customer.address }}</dd>
                  <dt class="col-md-4">&nbsp;</dt>
                  <dd class="col-md-8">
                    <button type="button" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-soft-primary" @click="getCustomerList" :disabled="workshop.lock"><i class="fa fa-search"></i> Search</button>
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <h5 class="text-ref-sales"><b>Data</b></h5>
                <dl class="row dl-custom font-12">
                  <dt class="col-md-4">Schedule Date</dt>
                  <dd class="col-md-8">
                    <span v-if="workshop.lock">{{ workshop.schedule_date | dateFormat('DD/MM/YYYY') }}</span>
                    <span v-else>
                      <datetime v-model="workshop.schedule_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                    </span>
                  </dd>
                  <dt class="col-md-4">Date</dt>
                  <dd class="col-md-8">
                    <span v-if="workshop.lock">{{ workshop.date_in | dateFormat('DD/MM/YYYY') }}</span>
                    <span v-else>
                      <datetime v-model="workshop.date_in" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                    </span>
                  </dd>
                  <dt class="col-md-4">Start</dt>
                  <dd class="col-md-8">
                    <span v-if="workshop.lock">{{ workshop.work_start | dateFormat('DD/MM/YYYY H:mm') }}</span>
                    <span v-else>
                      <datetime v-model="workshop.work_start" type="datetime" class="form-control" value-zone="local" zone="local"></datetime>
                    </span>
                  </dd>
                  <dt class="col-md-4">Finish</dt>
                  <dd class="col-md-8">
                    <span v-if="workshop.lock">{{ workshop.work_finish | dateFormat('DD/MM/YYYY H:mm') }}</span>
                    <span v-else>
                      <datetime v-model="workshop.work_finish" type="datetime" class="form-control" value-zone="local" zone="local"></datetime>
                    </span>
                  </dd>
                  <dt class="col-md-4">Mekanik</dt>
                  <dd class="col-md-8">
                    <v-select :options="employeeSelect" :reduce="employee => employee.meta.code" label="employee" v-model="workshop.mechanic_id" class="vsc-custom" :disabled="workshop.lock" />
                  </dd>
                </dl>
              </div>
              <div class="col-md-4">
                <h5 class="text-ref-sales"><b>Unit</b></h5>
                <dl class="row dl-custom">
                  <dt class="col-md-4">Vin Number</dt>
                  <dd class="col-md-5">
                    <span v-if="workshop.lock">{{ items.serial_number }}</span>
                    <span v-else>
                      <input type="text" v-model="items.serial_number" class="form-control"/>
                    </span>
                  </dd>
                  <dd class="col-md-3">
                    <button type="button" class="btn btn-sm btn-soft-primary" @click="getSerialNumber" :disabled="workshop.lock"><i class="fa fa-search"></i></button>
                  </dd>

                  <dt class="col-md-4">Product No.</dt>
                  <dd class="col-md-8">
                    <span v-if="workshop.lock"><b>{{ items.product_no }}</b></span>
                    <span v-else>
                      <v-select :options="productSelect" :reduce="product => product.meta.code" label="product" v-model="items.product_no" @input="itemProductSelect"/>
                    </span>
                  </dd>

                  <dt class="col-md-4">Description</dt>
                  <dd class="col-md-8">
                    <textarea class="form-control" v-model="items.description"></textarea>
                  </dd>

                  <dt class="col-md-4">Hours</dt>
                  <dd class="col-md-8">
                    <span v-if="workshop.lock">{{ items.hours }}</span>
                    <span v-else><input type="text" v-model="items.hours" class="form-control"/></span>
                  </dd>

                  <dt class="col-md-4">Kilometer</dt>
                  <dd class="col-md-8">
                    <span v-if="workshop.lock">{{ items.kilometer }}</span>
                    <span v-else><input type="text" v-model="items.kilometer" class="form-control"/></span>
                  </dd>
                </dl>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-md-6">
                <dl>
                  <dt class="col-md-4"><h5><b class="text-ref-sales">Symtoms:</b></h5></dt>
                  <dd class="col-md-8">
                    <textarea class="form-control" v-model="workshop.customer_note" rows="6" :disabled="workshop.lock"></textarea>
                  </dd>
                </dl>
              </div>
              <div class="col-md-6">
                <dl>
                  <dt class="col-md-4"><h5><b class="text-ref-sales">Notes:</b></h5></dt>
                  <dd class="col-md-8">
                    <textarea class="form-control" v-model="workshop.notes" rows="6" :disabled="workshop.lock"></textarea>
                  </dd>
                </dl>
              </div>
            </div>
            <hr/>
            <!-- workshop_no', 'sale_date', 'branch_no', 'product_no', 'product_sku', 'description', 'qty', 'serial_number', 'sec_serial_number', 'uom_id', 'price', 'tax_id', 'tax', 'discount', 'total', 'warehouse_no', 'status', 'estimated_date', 'type' -->
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <h5 class="text-ref-sales"><b>Services:</b></h5>
                  <table class="table table-sm table-item table-striped">
                    <thead>
                      <th style="width: 20%">Product</th>
                      <th style="width: 30%">Description</th>
                      <th style="width: 10%">hours</th>
                      <th>#</th>
                    </thead>
                    <tbody>
                      <tr v-for="(s, index) in services" :key="index">
                        <td>
                          <span v-if="workshop.lock">{{ s.product_no}}</span>
                          <span v-else>
                            <v-select :options="productSelect" :reduce="product => product.meta.code" label="product" v-model="s.product_no" @input="setServiceDetailRow(index)"/>
                          </span>
                        </td>
                        <td>{{ s.description }}</td>
                        <td>
                          <span v-if="workshop.lock">{{ s.qty }}</span>
                          <span v-else><input type="text" v-model="s.qty" class="form-control" :disabled="workshop.lock"/></span>
                        </td>
                        <td>
                          <span v-if="workshop.lock"></span>
                          <span v-else>
                            <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeService(index)"><i class="fa fa-trash"></i></button>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="5">
                          <span @click="addServiceLine" class="link-secondary" v-if="workshop.lock === false">Add Service</span>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <hr>
                  <h5 class="text-ref-sales"><b>Sparepart:</b></h5>
                  <table class="table table-sm table-item table-striped">
                    <thead>
                      <th style="width: 20%">Product</th>
                      <th style="width: 30%">Description</th>
                      <th style="width: 10%">Qty</th>
                      <th style="width: 10%">Uom</th>
                      <th style="width: 10%">Status</th>
                      <th style="width: 10%">Estimate Date</th>
                      <th>#</th>
                    </thead>
                    <tbody>
                      <tr v-for="(s, index) in spareparts" :key="index">
                        <td>
                          <span v-if="workshop.lock">
                            {{ s.product_no }}
                          </span>
                          <span v-else>
                            <v-select :options="productSelect" :reduce="product => product.meta.code" label="product" v-model="s.product_no" @input="setSparepartDetailRow(index)"/>
                          </span>
                        </td>
                        <td>{{ s.description }}</td>
                        <td>
                          <span v-if="workshop.lock">{{ s.qty }}</span>
                          <span v-else><input type="text" v-model="s.qty" class="form-control" /></span>
                        </td>
                        <td>
                          <span v-if="workshop.lock">{{ s.uom_id }}</span>
                          <span v-else>
                            <select class="form-control" v-model="s.uom_id">
                              <option v-for="u in s.uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                            </select>
                          </span>
                        </td>
                        <td>
                          <span v-if="workshop.lock">
                            <span class="badge badge-warning" v-if="s.status === 'indent'">{{ s.status }}</span>
                            <span class="badge badge-success" v-else>{{ s.status }}</span>
                          </span>
                          <span v-else>
                            <select class="form-control" v-model="s.status">
                              <option value="indent">Indent</option>
                              <option value="ready">Ready</option>
                            </select>
                          </span>
                        </td>
                        <td>
                          <span v-if="workshop.lock">{{ s.estimated_date | dateFormat('DD/MM/YYYY') }}</span>
                          <span v-else>
                            <span v-if="s.status === 'indent'">
                              <datetime v-model="s.estimated_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="workshop.lock"></span>
                          <span v-else>
                            <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeSparepart(index)"><i class="fa fa-trash"></i></button>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="5">
                          <span @click="addSparepartLine" class="link-secondary" v-if="workshop.lock === false">Add Sparepart</span>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-6">
        <h5>Logs:</h5>
        <div class="alert alert-info" role="alert" v-for="l in workshop.logs" :key="l.id">
          <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><pre>{{ workshop }}</pre></div>
    </div>
    <CustomerListModal @selectCustomerList="selectCustomerList" />
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { inventoryUrl, productUrl, getHeader, workshopUrl } from '@/config'
import Loading from 'vue-loading-overlay'
import CustomerListModal from '@/components/customer/CustomerListModal.vue'

export default {
  name: 'WorkshopForm',
  props: ['workshop'],
  components: {
    Loading,
    CustomerListModal
  },
  data () {
    return {
      productSaldo: {},
      alert: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      employeeList: state => state.employees.employeeList,
      companyList: state => state.companies.companyList,
      workshopTypeList: state => state.workshops.workshopTypeList,
      productListSelect: state => state.products.productListSelect
    }),
    employeeSelect () {
      var array = this.employeeList
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          employee: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    productSelect () {
      var loop = []
      var array = this.productListSelect
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product: array[i].product_no + ' ' + array[i].product_name,
          meta: {
            code: array[i].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    items () {
      return this.workshop.items[0]
    },
    services () {
      return this.workshop.details.filter(d => d.type === 'services')
    },
    spareparts () {
      return this.workshop.details.filter(d => d.type === 'sparepart')
    }
  },
  methods: {
    async nextProcess () {
      var obj = {
        id: this.workshop.id
      }
      console.log(obj)
      await axios.post(workshopUrl + '/next-process', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.$swal('Workshop', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    itemProductSelect () {
      var prd = this.productListSelect.find(d => d.product_no === this.items.product_no)
      if (prd) {
        this.items.description = prd.product_name
      }
    },
    async getSerialNumber () {
      var obj = {
        barcode: this.items.serial_number
      }
      await axios.post(inventoryUrl + '/serial-number', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          var data = response.data.data
          this.items.product_no = data.product_no
          this.items.description = data.product.product_name
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    selectCustomerList (customer) {
      this.workshop.customer_no = customer.customer_no
      this.workshop.customer = customer
    },
    async getQtySaldo (product) {
      var obj = {
        product_no: product,
        date: this.workshop.date_in
      }
      var url = productUrl + '/cost/get-saldo'
      var data = {}
      await axios.post(url, obj, { headers: getHeader() })
        .then(response => {
          this.productSaldo = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      return data
    },
    removeService (index) {
      var detail = this.services[index]
      if (typeof detail.id === 'undefined') {
        var wiDX = this.workshop.details.findIndex(d => d.product_no === detail.product_no && d.type === 'services')
        this.workshop.details.splice(wiDX, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(workshopUrl + '/detail/' + detail.id, { headers: getHeader() })
              .then(response => {
                var wiDXd = this.workshop.details.findIndex(d => d.product_no === detail.product_no && d.type === 'services')
                this.workshop.details.splice(wiDXd, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
    },
    removeSparepart (index) {
      var detail = this.spareparts[index]
      if (typeof detail.id === 'undefined') {
        var wiDX = this.workshop.details.findIndex(d => d.product_no === detail.product_no && d.type === 'sparepart')
        this.workshop.details.splice(wiDX, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(workshopUrl + '/detail/' + detail.id, { headers: getHeader() })
              .then(response => {
                var wiDXa = this.workshop.details.findIndex(d => d.product_no === detail.product_no && d.type === 'sparepart')
                this.workshop.details.splice(wiDXa, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
    },
    async setSparepartDetailRow (index) {
      this.productSaldo = {}
      var data = this.spareparts[index]
      const product = this.productListSelect.find(d => d.product_no === data.product_no)
      var body = {
        product_no: product.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader() })
        .then(response => {
          data.uomList = response.data.data
          data.uom_id = product.uom_id
        })
      data.description = product.product_name
      await this.getQtySaldo(product.product_no)
      console.log('saldo: ')
      console.log(this.productSaldo)
      console.log(this.productSaldo.product_no)
      if (parseFloat(this.productSaldo.qty) > 0) {
        data.status = 'ready'
        data.estimated_date = null
        data.qty = this.productSaldo.qty
      } else {
        data.status = 'indent'
        data.qty = 0
      }
    },
    async setServiceDetailRow (index) {
      var data = this.services[index]
      const product = this.productListSelect.find(d => d.product_no === data.product_no)
      var body = {
        product_no: product.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader() })
        .then(response => {
          data.uomList = response.data.data
          data.uom_id = product.uom_id
        })
      data.description = product.product_name
      data.qty = 1
      data.status = 'ready'
    },
    addServiceLine () {
      var obj = {
        workshop_no: null,
        sale_date: null,
        branch_no: null,
        product_no: null,
        product_sku: null,
        description: null,
        qty: null,
        uom_id: null,
        serial_number: null,
        sec_serial_number: null,
        price: null,
        tax_id: null,
        tax: null,
        discount: null,
        total: null,
        warehouse_no: null,
        status: null,
        estimated_date: null,
        type: 'services'
      }
      this.workshop.details.push(obj)
    },
    addSparepartLine () {
      var obj = {
        workshop_no: null,
        sale_date: null,
        branch_no: null,
        product_no: null,
        product_sku: null,
        description: null,
        qty: null,
        uom_id: null,
        serial_number: null,
        sec_serial_number: null,
        price: null,
        tax_id: null,
        tax: null,
        discount: null,
        total: null,
        warehouse_no: null,
        status: null,
        estimated_date: null,
        type: 'sparepart'
      }
      this.workshop.details.push(obj)
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    async updateWorkshop () {
      console.log(workshopUrl + '/' + this.workshop.id)
      await axios.put(workshopUrl + '/' + this.workshop.id, this.workshop, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Workshop', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async createWorkshop () {
      await axios.post(workshopUrl, this.workshop, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Workshop', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async sendNotif (id) {
      var obj = {
        id: id
      }
      await axios.put(workshopUrl + '/notif/' + id, obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.$swal(
            'Success',
            'Succes send notif to Whatsapp',
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            'Cannot send notif',
            'error'
          )
        })
    },
    getCustomerList: function () {
      this.$store.dispatch('getCustomerList')
    },
    removeDetail (index) {
      var detail = this.workshop.details[index]
      if (detail.state === 'create') {
        if (index !== 0) {
          this.workshop.details.splice(index, 1)
        }
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(workshopUrl + '/detail/' + detail.id, { headers: getHeader() })
              .then(response => {
                this.workshop.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    removePart (index) {
      var part = this.workshop.parts[index]
      if (part.state === 'create') {
        if (index !== 0) {
          this.workshop.parts.splice(index, 1)
        }
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            if (part.id) {
              axios.delete(workshopUrl + '/part/' + part.id, { headers: getHeader() })
                .then(response => {
                  this.workshop.parts.splice(index, 1)
                })
                .catch(error => {
                  console.log(error.response)
                })
            } else {
              this.workshop.parts.splice(index, 1)
            }
          }
        })
      }
    }
  }
}
</script>
